import {
  createTheme,
  CssBaseline,
  StyledEngineProvider,
  ThemeProvider,
} from '@mui/material';
import React from 'react';
import palette from 'theme/palette';
import { customShadows } from 'theme/shadows';
import shape from 'theme/shape';
import typography from 'theme/typography';
import componentsOverride from 'theme/overrides/index';
import GlobalStyles from 'theme/globalStyles';

interface IProps {
  children: React.ReactChild;
}

const themeOptions = {
  palette,
  shape,
  typography,
  customShadows,
} as const;

export function MuiProvider({ children }: IProps) {
  const theme = createTheme(themeOptions);
  theme.components = componentsOverride(theme);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
